var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AchievementService } from '../../../shared/services/achievement.service';
import { MatTableDataSource } from '@angular/material';
import { StatisticService } from '../../../shared/services/statistic.service';
import * as moment from 'moment';
import { InfoPopupComponent } from '../info-popup/info-popup.component';
import { UserService } from '../../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
var RankingAchievementComponent = (function () {
    function RankingAchievementComponent(stats, userService, achievementService) {
        this.stats = stats;
        this.userService = userService;
        this.achievementService = achievementService;
        this.displayedColumns = ['position', 'name', 'badges', 'punkte'];
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        this.aliasForm = new FormGroup({
            alias: new FormControl('', [Validators.maxLength(30)]),
        });
        this.date = moment();
        this.loadLeaderboard();
    }
    RankingAchievementComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
            var alias = user.alias;
            if (!alias) {
                _this.aliasPopup.show();
            }
        });
    };
    RankingAchievementComponent.prototype.loadLeaderboard = function (month, year) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var data, index, promises, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.stats.getCompanyLeaderboard(month, year)];
                    case 1:
                        data = _a.sent();
                        // order from highest to lowest points
                        data.sort(function (a, b) { return b.points - a.points; });
                        for (index = 0; index < data.length; index++) {
                            data[index].position = index + 1;
                        }
                        promises = data.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var achievements, displayCount, topThree;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.achievementService.getAchievementsForLeaderboard(item._id)];
                                    case 1:
                                        achievements = _a.sent();
                                        displayCount = achievements.length - 3;
                                        topThree = achievements.slice(0, 3);
                                        if (displayCount < 0) {
                                            displayCount = 0;
                                        }
                                        item.badges = { achievement: topThree, count: displayCount };
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        // Wait for all the promises to resolve before proceeding
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        // Wait for all the promises to resolve before proceeding
                        _a.sent();
                        this.dataSource = new MatTableDataSource(data);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error loading leaderboard:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RankingAchievementComponent.prototype.getCurrentAchievementLevel = function (achievement) {
        var progress = achievement.progress;
        var levels = achievement.levels;
        var levelsArr = ['green', 'bronze', 'silber', 'gold'];
        if (levels) {
            var progressToNextLevel = progress;
            var currentLevel = 'unlocked';
            for (var _i = 0, levelsArr_1 = levelsArr; _i < levelsArr_1.length; _i++) {
                var levelName = levelsArr_1[_i];
                var level = levels[levelName];
                if (progressToNextLevel >= level) {
                    currentLevel = levelName;
                    progressToNextLevel -= level;
                }
                else {
                    break; // Stop checking once the current level is found
                }
            }
            return currentLevel;
        }
        else if (achievement.finishedAt || (!achievement.hasLevels && achievement.progress === 1)) {
            return 'gold';
        }
        else {
            return 'unlocked';
        }
    };
    RankingAchievementComponent.prototype.nextMonth = function () {
        this.date.add(1, 'M');
        this.loadLeaderboard(this.date.month() + 1, this.date.year());
    };
    RankingAchievementComponent.prototype.prevMonth = function () {
        this.date.subtract(1, 'M');
        this.loadLeaderboard(this.date.month() + 1, this.date.year());
    };
    RankingAchievementComponent.prototype.saveAlias = function (anonym) {
        var _this = this;
        if (!anonym && !this.aliasForm.valid) {
            return;
        }
        var alias = anonym ? 'anonym' : this.aliasForm.value.alias ? this.aliasForm.value.alias : 'anonym';
        this.userService
            .updateUser({
            alias: alias,
        })
            .then(function () { return _this.userService.getThisUser(); });
        this.dataSource.data.find(function (item) { return item.isRequester === true; }).alias = alias;
        this.aliasPopup.close();
    };
    return RankingAchievementComponent;
}());
export { RankingAchievementComponent };
var ELEMENT_DATA = [
    { position: 0, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
    { position: 1, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
    { position: 2, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
    { position: 3, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
    { position: 4, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
    { position: 5, alias: '...', points: 0, isRequester: false, badges: { achievement: [], count: 0 } },
];



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/ranking-achievements/ranking-achievement.component.ts.pre-build-optimizer.js